import { render } from "./Dashboard4.html?vue&type=template&id=6b2e8d9f&scoped=true&ts=true"
import script from "./Dashboard4.ts?vue&type=script&lang=ts"
export * from "./Dashboard4.ts?vue&type=script&lang=ts"

import "./Dashboard4.scss?vue&type=style&index=0&id=6b2e8d9f&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2e8d9f"]])

export default __exports__